
import './pl_landlord.css';
import StaffMockHost from './staff-mock-host.vue';
import LandlordSettings from '../owner/widgets/landlord-settings.vue';
import MonthUpload from '../owner/widgets/month-upload.vue';
import ImportantNotice from '../owner/widgets/important-notice.vue';
import StayReview from '../owner/widgets/stay-review.vue';
import PickRoom from '../owner/widgets/pick-room.vue';
import DialogNotice from '../owner/widgets/dialog-notice.vue';

export default {
  name: 'pl-landlord-list',
  components: {
    StaffMockHost: StaffMockHost,
    LandlordSettings: LandlordSettings,
    MonthUpload: MonthUpload,
    ImportantNotice: ImportantNotice,
    StayReview: StayReview,
    PickRoom: PickRoom,
    DialogNotice: DialogNotice
  },
  data: function () {
    return {
      keyword: '',
      kwTimer: null,
      kpis: [
        { key: 'landlords_active', label: '在籍オーナー', value: 0 },
        { key: 'rooms_unassigned', label: '未割り当ての宿', value: 0 },
        { key: 'stays_pending', label: '承認待ち試泊', value: 0 }
      ],
      landlords: [],
      mockCardHold: false,
      editingId: null,
      editingLandlord: null,
      pendingType: '',
      pendingYear: null,
      pendingMonth: null,
      noticeLandlordId: null,
      stayLandlordId: null,
      stayNoticeBody: '',
      stayNoticeLandlordId: null,
      staySeenKey: '',
      stayTimer: null,
      addLandlordId: null,
      ui: {
        settings: false,
        monthUpload: false,
        noticePanel: false,
        stay: false,
        stayNotice: false,
        addRoom: false
      }
    };
  },
  watch: {
    keyword: function () {
      var t = this;
      clearTimeout(t.kwTimer);
      t.kwTimer = setTimeout(function () {
        t.loadList();
      }, 300);
    }
  },
  created: function () {
    this.$eventBus.$on('pl-mock-sample-card', this.applyMockCard);
    this.loadList();
    this.loadStats();
    this.pollStays();
    this.startStayPoll();
  },
  activated: function () {
    this.loadList();
    this.pollStays();
    this.startStayPoll();
  },
  deactivated: function () {
    this.stopStayPoll();
  },
  beforeDestroy: function () {
    clearTimeout(this.kwTimer);
    this.stopStayPoll();
    this.$eventBus.$off('pl-mock-sample-card', this.applyMockCard);
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastMock: function () {
      this.toast('mock：未接线');
    },
    toastFail: function (status) {
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else this.toast('取得に失敗しました');
    },
    cardName: function (card) {
      if (card.account_type && card.account_type !== 'owner' && card.company_name) return card.company_name;
      if (card.name) return card.name;
      return (card.lastname || '') + (card.firstname || '');
    },
    activeRooms: function (card) {
      return card.rooms || [];
    },
    pastRooms: function (card) {
      var active = {};
      (card.rooms || []).forEach(function (room) {
        active[room.id] = true;
      });
      return (card.past_rooms || []).filter(function (room) {
        return room && room.id && !active[room.id];
      });
    },
    applyKpi: function (opt) {
      opt = opt || {};
      this.kpis = [
        { key: 'landlords_active', label: '在籍オーナー', value: Number(opt.landlords_active) || 0 },
        { key: 'rooms_unassigned', label: '未割り当ての宿', value: Number(opt.rooms_unassigned) || 0 },
        { key: 'stays_pending', label: '承認待ち試泊', value: Number(opt.stays_pending) || 0 }
      ];
    },
    loadStats: function () {
      var t = this;
      axios.get('landlord/stats').then(function (res) {
        if (res.data.status != 1) {
          return;
        }
        t.applyKpi(res.data.options);
      }).catch(function () { });
    },
    applyMockCard: function () {
      this.mockCardHold = true;
      this.landlords = [{
        id: 9001,
        name: '京蘭　一太朗',
        stays_pending: 1,
        avatar_url: '',
        rooms: [
          { id: 1, name: '〇〇〇〇〇邸' },
          { id: 2, name: '〇〇〇〇〇邸' }
        ],
        past_rooms: [{ id: 3, name: '旧〇〇邸' }]
      }];
    },
    loadList: function () {
      if (this.mockCardHold) return;
      var t = this;
      var params = { status: 1 };
      var kw = (this.keyword || '').trim();
      if (kw) params.keyword = kw;
      axios.get('landlord', { params: params }).then(function (res) {
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          t.landlords = [];
          return;
        }
        t.landlords = (res.data.options && res.data.options.items) || [];
      }).catch(function () {
        t.toast('通信に失敗しました');
        t.landlords = [];
      });
    },
    openUpload: function (type) {
      this.pendingType = type;
      this.ui.monthUpload = true;
    },
    onMonthPicked: function (payload) {
      this.pendingYear = payload && payload.year;
      this.pendingMonth = payload && payload.month;
      var t = this;
      this.$nextTick(function () {
        if (t.$refs.pubFile) t.$refs.pubFile.click();
      });
    },
    onPubFile: function (e) {
      var file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      var fd = new FormData();
      fd.append('file', file);
      fd.append('type', this.pendingType);
      fd.append('year', this.pendingYear);
      fd.append('month', this.pendingMonth);
      var t = this;
      axios.post('landlord/publication/upload', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function (res) {
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          return;
        }
        t.toast('アップロードしました');
      }).catch(function () {
        t.toast('通信に失敗しました');
      });
    },
    openCreate: function () {
      this.editingId = null;
      this.editingLandlord = null;
      this.ui.settings = true;
    },
    openSettings: function (card) {
      this.editingId = card.id;
      this.editingLandlord = card;
      this.ui.settings = true;
    },
    onCardNotice: function (card) {
      if (!card || !card.id) {
        this.toast('オーナーが指定されていません');
        return;
      }
      this.noticeLandlordId = card.id;
      this.ui.noticePanel = true;
    },
    goFacility: function (room) {
      if (!room || !room.id) {
        this.toast('宿が指定されていません');
        return;
      }
      this.$router.push({
        path: '/rooms',
        query: { room_id: room.id }
      });
    },
    onAddChip: function (card) {
      if (!card || !card.id) {
        this.toast('オーナーが指定されていません');
        return;
      }
      this.addLandlordId = card.id;
      this.ui.addRoom = true;
    },
    onSaved: function () {
      this.loadList();
      this.loadStats();
    },
    onResigned: function () {
      this.loadList();
      this.loadStats();
    },
    lastSettlementMonth: function () {
      var now = new Date();
      var y = now.getFullYear();
      var m = now.getMonth();
      if (m < 1) {
        return { year: y - 1, month: 12 };
      }
      return { year: y, month: m };
    },
    goSettlement: function (card) {
      if (!card || !card.id) {
        this.toast('オーナーが指定されていません');
        return;
      }
      var ym = this.lastSettlementMonth();
      this.$router.push({
        path: '/pl_landlord_settlement',
        query: {
          landlord_id: card.id,
          year: ym.year,
          month: ym.month
        }
      });
    },
    openStay: function (card) {
      if (!card || !card.id) {
        this.toast('オーナーが指定されていません');
        return;
      }
      this.stayLandlordId = card.id;
      this.ui.stay = true;
    },
    startStayPoll: function () {
      this.stopStayPoll();
      var t = this;
      this.stayTimer = setInterval(function () {
        t.pollStays();
      }, 15000);
    },
    stopStayPoll: function () {
      clearInterval(this.stayTimer);
      this.stayTimer = null;
    },
    pollStays: function () {
      if (this._inactive) return;
      var t = this;
      axios.get('ownerStay', { params: { status: 'pending' } }).then(function (res) {
        if (t._inactive) return;
        if (!(res.data && res.data.status == 1 && res.data.options)) return;
        var items = res.data.options.items || [];
        var ids = items.map(function (it) { return it.id; }).sort(function (a, b) { return a - b; });
        var key = ids.join(',');
        if (!key || key === t.staySeenKey || t.ui.stayNotice) return;
        t.staySeenKey = key;
        t.stayNoticeBody = items.map(function (it) {
          var name = it.landlord_name || 'オーナー';
          var room = it.room_name || '部屋';
          var from = it.stay_date || '';
          var to = it.date_to && it.date_to !== from ? ('〜' + it.date_to) : '';
          return name + '様より' + room + 'の試泊申請がありました（' + from + to + '）';
        }).join('\n');
        t.stayNoticeLandlordId = items[0] ? items[0].landlord_id : null;
        t.ui.stayNotice = true;
        t.loadList();
      });
    },
    onStayNoticeClose: function () {
      if (!this.stayNoticeLandlordId) return;
      this.stayLandlordId = this.stayNoticeLandlordId;
      this.ui.stay = true;
    },
    onStayDone: function () {
      this.loadList();
      this.loadStats();
    }
  }
};
